module.exports = "<!-- PLEASE GIVE UNIQUE ID TO EACH TAG. THANK YOU -->\r\n\r\n<p>\r\n  message works!\r\n</p>\r\n"